package org.multipaz.utopia.generated

/**
 * Generated strings for language: da
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_da = mapOf(
    "boarding_pass_attribute_departure_time" to "Afrejsetid",
    "boarding_pass_attribute_flight_number" to "Flynummer",
    "boarding_pass_attribute_passenger_name" to "Passagernavn",
    "boarding_pass_attribute_seat_number" to "Sædenummer",
    "boarding_pass_description_departure_time" to "Dato og tid for afrejse",
    "boarding_pass_description_flight_number" to "Flynummeret",
    "boarding_pass_description_passenger_name" to "Efternavn, slægtsnavn eller primær identifikator for mDL-indehaveren.",
    "boarding_pass_description_seat_number" to "Sædenummeret",
    "cor_attribute_administrative_number" to "Administrativt nummer",
    "cor_attribute_date_of_arrival" to "Ankomstdato",
    "cor_attribute_date_of_birth" to "Fødselsdato",
    "cor_attribute_date_of_expiry" to "Udløbsdato",
    "cor_attribute_date_of_issue" to "Udstedelsesdato",
    "cor_attribute_document_number" to "Dokumentnummer",
    "cor_attribute_family_name" to "Efternavn",
    "cor_attribute_gender" to "Køn",
    "cor_attribute_given_names" to "Fornavne",
    "cor_attribute_issuing_authority" to "Udstedende myndighed",
    "cor_attribute_issuing_country" to "Udstedelsesland",
    "cor_attribute_issuing_jurisdiction" to "Udstedende jurisdiktion",
    "cor_attribute_nationality" to "Nationalitet",
    "cor_attribute_older_than_18" to "Ældre end 18",
    "cor_attribute_older_than_21" to "Ældre end 21",
    "cor_attribute_place_of_birth" to "Fødested",
    "cor_attribute_resident_address" to "Bopælsadresse",
    "cor_attribute_resident_city" to "Bopælsby",
    "cor_attribute_resident_country" to "Bopælsland",
    "cor_attribute_resident_house_number" to "Bopælshusnummer",
    "cor_attribute_resident_postal_code" to "Bopælspostnummer",
    "cor_attribute_resident_state" to "Bopælsdelstat",
    "cor_attribute_resident_street" to "Bopælsgade",
    "cor_description_administrative_number" to "Et nummer tildelt af COR-udbyderen til revisionskontrol eller andre formål.",
    "cor_description_date_of_arrival" to "Dag, måned og år for COR-indehaverens ankomst til EU.",
    "cor_description_date_of_birth" to "Dag, måned og år for COR-indehaverens fødsel. Hvis ukendt, omtrentlig fødselsdato.",
    "cor_description_date_of_expiry" to "Dato (og eventuelt tidspunkt) for udløb af COR.",
    "cor_description_date_of_issue" to "Dato (og eventuelt tidspunkt) for udstedelse af COR.",
    "cor_description_document_number" to "Et nummer for COR'en, tildelt af COR-udbyderen.",
    "cor_description_family_name" to "Nuværende efternavn(e) eller primær identifikation af COR-indehaveren",
    "cor_description_gender" to "COR-indehaverens køn.",
    "cor_description_given_names" to "Nuværende fornavn(e), andre navne eller sekundær identifikation af COR-indehaveren",
    "cor_description_issuing_authority" to "Navnet på den administrative myndighed, der har udstedt denne COR-instans, eller ISO 3166 Alpha-2 landekoden for den respektive medlemsstat, hvis der ikke er en særskilt myndighed autoriseret til at udstede COR'er.",
    "cor_description_issuing_country" to "Alpha-2 landekode, som defineret i ISO 3166-1, for den udstedende myndigheds land eller territorium",
    "cor_description_issuing_jurisdiction" to "Landets underopdelingskode for den jurisdiktion, der udstedte COR'en, som defineret i ISO 3166-2:2020, Klausul 8. Den første del af koden SKAL være den samme som værdien for udstedelsesland.",
    "cor_description_nationality" to "Alpha-2 landekode som specificeret i ISO 3166-1, der repræsenterer brugerens nationalitet.",
    "cor_description_older_than_18" to "Alder over 18?",
    "cor_description_older_than_21" to "Alder over 21?",
    "cor_description_place_of_birth" to "Stedet hvor COR-indehaveren blev født.",
    "cor_description_resident_address" to "Den fulde adresse på det sted, hvor COR-indehaveren aktuelt bor og/eller kan kontaktes (gade/husnummer, kommune mv.)",
    "cor_description_resident_city" to "Byen hvor COR-indehaveren aktuelt bor.",
    "cor_description_resident_country" to "Landet hvor brugeren aktuelt bor, som en Alpha-2 landekode som specificeret i ISO 3166-1",
    "cor_description_resident_house_number" to "Husnummeret hvor brugeren aktuelt bor, inklusive eventuelt præfiks eller suffiks.",
    "cor_description_resident_postal_code" to "Postnummeret for stedet hvor COR-indehaveren aktuelt bor.",
    "cor_description_resident_state" to "Delstaten, provinsen, distriktet eller lokalområdet, hvor brugeren aktuelt bor.",
    "cor_description_resident_street" to "Navnet på gaden hvor brugeren aktuelt bor.",
    "cor_request_age_over_18" to "Alder over 18",
    "cor_request_all_data_elements" to "Alle dataelementer",
    "cor_request_mandatory_data_elements" to "Obligatoriske dataelementer",
    "document_display_name_boarding_pass" to "Boardingkort",
    "document_display_name_certificate_of_residency" to "Bopælsattest",
    "document_display_name_german_personal_id" to "Tysk person-id",
    "document_display_name_loyalty_card" to "Loyalitetskort",
    "document_display_name_movie_ticket" to "Biografbillet",
    "document_display_name_naturalization_certificate" to "Indfødsretsbevis",
    "document_display_name_payment_card" to "Betalingskort",
    "german_id_attribute_administrative_number" to "Administrativt nummer",
    "german_id_attribute_age_in_years" to "Alder i år",
    "german_id_attribute_city_of_birth" to "Fødeby",
    "german_id_attribute_country_of_birth" to "Fødeland",
    "german_id_attribute_date_of_birth" to "Fødselsdato",
    "german_id_attribute_date_of_expiry" to "Udløbsdato",
    "german_id_attribute_date_of_issue" to "Udstedelsesdato",
    "german_id_attribute_document_number" to "Dokumentnummer",
    "german_id_attribute_family_name" to "Efternavn",
    "german_id_attribute_family_name_at_birth" to "Efternavn ved fødslen",
    "german_id_attribute_gender" to "Køn",
    "german_id_attribute_given_names" to "Fornavne",
    "german_id_attribute_issuing_authority" to "Udstedende myndighed",
    "german_id_attribute_issuing_country" to "Udstedende land",
    "german_id_attribute_issuing_jurisdiction" to "Udstedende jurisdiktion",
    "german_id_attribute_nationality" to "Nationalitet",
    "german_id_attribute_older_than_12" to "Over 12 år",
    "german_id_attribute_older_than_14" to "Over 14 år",
    "german_id_attribute_older_than_16" to "Over 16",
    "german_id_attribute_older_than_18" to "Over 18",
    "german_id_attribute_older_than_21" to "Over 21",
    "german_id_attribute_older_than_65" to "Over 65",
    "german_id_attribute_place_of_birth" to "Fødested",
    "german_id_attribute_resident_address" to "Bopælsadresse",
    "german_id_attribute_resident_city" to "Bopælsby",
    "german_id_attribute_resident_country" to "Bopælsland",
    "german_id_attribute_resident_postal_code" to "Bopælspostnummer",
    "german_id_attribute_state_of_birth" to "Fødedelstat",
    "german_id_attribute_year_of_birth" to "Fødselsår",
    "german_id_description_administrative_number" to "Et nummer tildelt af PID-udbyderen til revisionskontrol eller andre formål.",
    "german_id_description_age_in_years" to "PID-indehaverens alder i år",
    "german_id_description_city_of_birth" to "Kommunen, byen eller landsbyen, hvor PID-brugeren er født",
    "german_id_description_country_of_birth" to "Landet, hvor PID-brugeren blev født, som en Alpha-2 landekode som specificeret i ISO 3166-1",
    "german_id_description_date_of_birth" to "Dag, måned og år, hvor PID-indehaveren blev født. Hvis ukendt, omtrentlig fødselsdato.",
    "german_id_description_date_of_expiry" to "Dato (og eventuelt klokkeslæt), da PID'en udløber.",
    "german_id_description_date_of_issue" to "Dato (og eventuelt klokkeslæt), da PID'en blev udstedt.",
    "german_id_description_document_number" to "Et nummer for PID'et, tildelt af PID-udbyderen.",
    "german_id_description_family_name" to "Nuværende efternavn(e) eller primær identifikator af PID-indehaveren",
    "german_id_description_family_name_at_birth" to "Efternavn(e) eller primær identifikator for PID-indehaveren ved fødsel",
    "german_id_description_gender" to "PID-indehaverens køn",
    "german_id_description_given_names" to "Nuværende fornavn(e), andre navn(e) eller sekundær identifikator af PID-indehaveren",
    "german_id_description_issuing_authority" to "Navnet på den administrative myndighed, der har udstedt denne PID-instans, eller ISO 3166 Alpha-2 landekoden for den respektive medlemsstat, hvis der ikke er en separat myndighed autoriseret til at udstede PID'er.",
    "german_id_description_issuing_country" to "Alpha-2 landekode, som defineret i ISO 3166-1, for den udstedende myndigheds land eller territorium.",
    "german_id_description_issuing_jurisdiction" to "Landunderinddelingskode for den jurisdiktion, der udstedte PID'et, som defineret i ISO 3166-2:2020, punkt 8. Den første del af koden SKAL være den samme som værdien for issuing_country.",
    "german_id_description_nationality" to "Liste over Alpha-2 landekoder i henhold til ISO 3166-1, der repræsenterer PID-brugerens nationalitet.",
    "german_id_description_older_than_12" to "Over 12 år?",
    "german_id_description_older_than_14" to "Over 14 år?",
    "german_id_description_older_than_16" to "Over 16 år?",
    "german_id_description_older_than_18" to "Over 18 år?",
    "german_id_description_older_than_21" to "Over 21 år?",
    "german_id_description_older_than_65" to "Over 65 år?",
    "german_id_description_place_of_birth" to "Land og kommune eller delstat/provins, hvor PID-indehaveren blev født",
    "german_id_description_resident_address" to "Den fulde adresse for det sted, hvor PID-indehaveren aktuelt bor og/eller kan kontaktes (vej/husnummer, kommune osv.)",
    "german_id_description_resident_city" to "Byen, hvor PID-indehaveren aktuelt bor",
    "german_id_description_resident_country" to "Landet, hvor PID-brugeren aktuelt bor, som en Alpha-2 landekode i henhold til ISO 3166-1",
    "german_id_description_resident_postal_code" to "Postnummeret for det sted, hvor PID-indehaveren aktuelt bor",
    "german_id_description_state_of_birth" to "Delstat, provins, distrikt eller lokalområde, hvor PID-brugeren blev født",
    "german_id_description_year_of_birth" to "Året hvor PID-indehaveren blev født",
    "german_id_request_age_over_18" to "Alder over 18",
    "german_id_request_all_data_elements" to "Alle dataelementer",
    "german_id_request_mandatory_data_elements" to "Obligatoriske dataelementer",
    "loyalty_attribute_date_of_expiry" to "Udløbsdato",
    "loyalty_attribute_date_of_issue" to "Udstedelsesdato",
    "loyalty_attribute_family_name" to "Efternavn",
    "loyalty_attribute_given_names" to "Fornavne",
    "loyalty_attribute_membership_id" to "Medlems-ID",
    "loyalty_attribute_photo_of_holder" to "Billede af indehaver",
    "loyalty_attribute_tier" to "Niveau",
    "loyalty_description_date_of_expiry" to "Udløbsdato",
    "loyalty_description_date_of_issue" to "Udstedelsesdato",
    "loyalty_description_family_name" to "Dokumentindehaverens efternavn eller primære identifikation",
    "loyalty_description_given_names" to "Dokumentindehaverens fornavn(e) eller sekundære identifikation",
    "loyalty_description_membership_id" to "Identifikator for loyalitets-ID-indehaveren",
    "loyalty_description_photo_of_holder" to "Dokumentindehaverens portrætbillede",
    "loyalty_description_tier" to "Medlemskabsniveau (basis, sølv, guld, platin, elite)",
    "loyalty_request_all_data_elements" to "Alle dataelementer",
    "loyalty_request_mandatory_data_elements" to "Obligatoriske dataelementer",
    "movie_ticket_attribute_age_rating_code" to "Aldersgrænse",
    "movie_ticket_attribute_cinema_theater" to "Biograf",
    "movie_ticket_attribute_date_and_time_of_show" to "Dato og tidspunkt for forestilling",
    "movie_ticket_attribute_movie_poster" to "Filmplakat",
    "movie_ticket_attribute_movie_title" to "Filmtitel",
    "movie_ticket_attribute_parking" to "Parkering",
    "movie_ticket_attribute_seat" to "Sæde",
    "movie_ticket_attribute_theater" to "Biograf",
    "movie_ticket_attribute_ticket_number" to "Billetnummer",
    "movie_ticket_description_age_rating_code" to "Aldersklassificeringskode for aldersbegrænsninger",
    "movie_ticket_description_cinema_theater" to "Biografens navn og/eller adresse/sted for adgang.",
    "movie_ticket_description_date_and_time_of_show" to "Dato og tidspunkt for filmstart",
    "movie_ticket_description_movie_poster" to "Filmplakat",
    "movie_ticket_description_movie_title" to "Filmnavn, titel og andre identifikationsoplysninger om forestillingen.",
    "movie_ticket_description_parking" to "Angiver om parkering er forudbetalt med billetkøbet",
    "movie_ticket_description_seat" to "Sædenummer eller -kode (f.eks. række/sæde)",
    "movie_ticket_description_theater" to "Navn eller nummer på sal",
    "movie_ticket_description_ticket_number" to "Billetidentifikations-/referencenummer udstedt ved købstidspunktet.",
    "movie_ticket_request_all_data_elements" to "Alle dataelementer",
    "movie_ticket_request_prepaid_parking" to "Forudbetalt parkering",
    "movie_ticket_request_ticket_number" to "Billetnummer",
    "naturalization_attribute_date_of_birth" to "Fødselsdato",
    "naturalization_attribute_date_of_naturalization" to "Dato for naturalisering",
    "naturalization_attribute_family_name" to "Efternavn",
    "naturalization_attribute_given_names" to "Fornavne",
    "naturalization_description_date_of_birth" to "Dag, måned og år, hvor den naturaliserede person blev født. Hvis ukendt, omtrentlig fødselsdato.",
    "naturalization_description_date_of_naturalization" to "Dato (og eventuelt tidspunkt), hvor personen blev naturaliseret.",
    "naturalization_description_family_name" to "Nuværende efternavn(e) eller primær identifikation for den naturaliserede person",
    "naturalization_description_given_names" to "Nuværende fornavn(e), andre navn(e) eller sekundær identifikation for den naturaliserede person",
    "naturalization_request_all_data_elements" to "Alle dataelementer",
    "payment_attribute_expiry_date" to "Udløbsdato",
    "payment_attribute_holder_name" to "Indehaverens navn",
    "payment_attribute_issue_date" to "Udstedelsesdato",
    "payment_attribute_issuer_name" to "Udstederens navn",
    "payment_attribute_masked_account_reference" to "Maskeret kontoreference",
    "payment_attribute_payment_instrument_id" to "Betalingsinstrument-ID",
    "payment_description_expiry_date" to "Dato for udløb af denne legitimationsoplysning.",
    "payment_description_holder_name" to "Betalingskontohaverens navn.",
    "payment_description_issue_date" to "Dato for udstedelse af denne legitimationsoplysning.",
    "payment_description_issuer_name" to "Menneskeligt læsbart udstedernavn.",
    "payment_description_masked_account_reference" to "Maskeret kontoreference, f.eks. PAN's sidste 4.",
    "payment_description_payment_instrument_id" to "Tokeniseret betalingsinstrumentidentifikator.",
    "payment_request_payment_sca_all" to "Betaling SCA (alle dataelementer)",
    "payment_request_payment_sca_minimal" to "Betaling SCA (minimal)",
    "payment_request_payment_sca_transaction" to "SCA-godkendelse af betalingstransaktion"
)
